export default __webpack_public_path__ + "static/media/Ring of the Burning Beacon.0a7072e5.jpg";